<template>
    <defaultHotspot :hotspot="hotspot" :hotspotCount="hotspotCount" v-if="canAccessHotspot()"/>
    <hotspotPasswordForm :hotspot="hotspot" :hotspotCount="hotspotCount" v-else/>
</template>

<script>
import defaultHotspot from './defaultHotspot.vue';
import hotspotPasswordForm from './sub-components/hotspotPasswordForm.vue';

export default {
    props: ['hotspot', 'hotspotCount'],
    components: {
        defaultHotspot,
        hotspotPasswordForm
    },
    methods: {
        canAccessHotspot(){
            return this.$store.getters.getRestrictedAccessLogins.includes(this.hotspot.route);                
        }
    }
}
</script>